<template>
    <div class="info-wrap">
        <div class="info-items">
            <transition name="in-out-fade" mode="out-in">
                <div class="info-item" v-for="(item, index) in info" :key="index" v-if="item.active">
                    <h3 class="info-title">{{ item.title }}</h3>
                    <div class="info-icon">
                        <component :is="item.icon"></component>
                    </div>
                    <p class="info-tagline">{{ item.tagline }}</p>
                </div>
            </transition>
        </div>
        <div class="info-nav">
            <span v-for="(item, index) in info" :key="index" @click="toInfo(index)" class="info-nav-item" :class="{'active': item.active}"></span>
        </div>
        <ui-button :icon="'appStore'" :extraClass="'app-store'"></ui-button>
        <ui-button :icon="'googlePlay'" :extraClass="'google-play'"></ui-button>
    </div>
</template>

<script>
import Vue from 'vue';
import platform from '../assets/icons/platform';
import button from './elements/downloadButton';

Vue.component('platform-icon', platform);

export default {
  methods: {
    toInfo(index) {
      /* eslint no-param-reassign: 0 */
      /* eslint array-callback-return: 0 */
      /* eslint arrow-parens: 0 */
      this.info.map(el => {
        el.active = false;
      });
      this.info[index].active = true;
    }
  },
  data() {
    return {
      info: [
        {
          title: 'Payment platform',
          icon: 'platform-icon',
          tagline:
            'Packed with revolutionary features that make your more productive in the new world of borderless, operatorless and bankless money.',
          active: true
        },
        {
          title: 'Payment platform',
          icon: 'platform-icon',
          tagline:
            'Packed with revolutionary features that make your more productive in the new world of borderless, operatorless and bankless money.',
          active: false
        },
        {
          title: 'Payment platform',
          icon: 'platform-icon',
          tagline:
            'Packed with revolutionary features that make your more productive in the new world of borderless, operatorless and bankless money.',
          active: false
        }
      ]
    };
  },
  components: {
    'ui-button': button
  }
};
</script>


// WEBPACK FOOTER //
// src/components/infoWrap.vue